import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import {getSingleUserDetails, putSingleUserUpdate } from '../../redux/actions/AuthActions';
import { Link, useNavigate, useParams } from 'react-router-dom';
import NavbarTwo from '../../components/navbar/NavbarTwo';
import { SINGLE_USER_UPDATE_RESET } from '../../redux/constants/AuthConstants';


const ProfileUpdateScreen = ({getSingleUserDetails, authDetails, authUpdate, putSingleUserUpdate }) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { id } = useParams()

    const { loading, user, error } = authDetails;

    const {loading:updateLoading, success:updateSuccess, error:updateErr } = authUpdate;
    
    
    const [data, setData] = useState({
        name: '',
        email: '',
        phone: '',
        role: ''
    });

    
    const changeHandler = e => {
        const { name, value } = e.target;
        
        setData({
            ...data,
            [name]: value
        })
        
    }
    
    useEffect(() => {
        
        if (updateSuccess) {
            
            dispatch({
                type: SINGLE_USER_UPDATE_RESET
            })
            
            navigate('/admin/userList')
            
        }else {
            if (!user || user._id !== id) {
                getSingleUserDetails(id)
            }else{
                setData({
                    name: user.name,
                    email: user.email,
                    phone: user.phone,
                })
            }
        }
        
    }, [dispatch, getSingleUserDetails, id, navigate, updateSuccess, user])
    
    
    
    const submitHandler = e => {
        e.preventDefault()
        
        putSingleUserUpdate(user._id, data)
    }
    

    return (
        <div className='bg-gray-50 min-h-screen'>
            <NavbarTwo />
            <div className='container max-w-screen-xl mx-auto px-4'>
                <div className='my-10'>
                    <Link to='/admin/userList' className='px-5 py-3 bg-gray-200 hover:bg-gray-300 rounded text-sm font-medium tracking-wider'>GO BACK </Link>
                </div>
                {updateLoading && <Loader />}
                {updateErr && <Message error msg={updateErr} />}
                { loading ? <Loader /> : error ? <Message error msg={error} /> : (
                    <div className='flex justify-between flex-col lg:flex-row my-10'>
                    <div className='w-full lg:mr-5 order-2 lg:order-none'>
                        <h2 className='text-4xl font-light uppercase mb-4'>update</h2>
                        <form onSubmit={submitHandler}>
                            <div className="mb-6">
                                <label htmlFor='name' className="block mb-2 text-sm font-medium text-gray-900 ">Username <span className='text-red-500 text-base'>*</span></label>
                                <input 
                                    type="text" 
                                    id="name"
                                    name="name"
                                    onChange={changeHandler}
                                    value={data.name} 
                                    placeholder="name"
                                    className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                />
                            </div>
                            <div className="mb-6">
                                <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 ">Email <span className='text-red-500 text-base'>*</span></label>
                                <input 
                                    type="email" 
                                    id="email"
                                    name="email"
                                    onChange={changeHandler} 
                                    value={data.email}
                                    placeholder="example@support.com" 
                                    className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                />
                            </div>
                            <div className="mb-6">
                                <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 ">Phone No <span className='text-red-500 text-base'>*</span></label>
                                <input 
                                    type="number" 
                                    id="phone"
                                    name="phone"
                                    onChange={changeHandler} 
                                    value={data.phone} 
                                    placeholder="112456789" 
                                    className="no__arrow shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                />
                            </div>
                            <div className="mb-6">
                                <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 ">Role<span className='text-red-500 text-base'>*</span></label>
                                <div className="flex items-center mb-6">
                                    <input id="role-user"  type="radio" value='user' onChange={changeHandler} name="role" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 " />
                                    <label htmlFor="role-user" className="ml-2 text-sm font-medium text-gray-900">User</label>
                                </div>
                                
                                <div className="flex items-center mb-6">
                                    <input id="role-maker" type="radio" value='artisan' onChange={changeHandler} name="role" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 " />
                                    <label htmlFor="role-maker" className="ml-2 text-sm font-medium text-gray-900">Artisan</label>
                                </div>
                                <div className="flex items-center mb-6">
                                    <input id="role-admin" type="radio" value='admin' onChange={changeHandler} name="role" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500" />
                                    <label htmlFor="role-admin" className="ml-2 text-sm font-medium text-gray-900">Admin</label>
                                </div>
                            </div>
                            
                            <button type="submit" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none sen-font uppercase focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Update profile</button>
                        </form>
                    </div>
                    <div className='w-full lg:ml-5'>
                        <h2 className='text-4xl font-light uppercase mb-4'>profile</h2>
                        <div className="relative overflow-x-auto my-10">
                            <table className="w-full text-sm text-left text-black">
                                <thead className="text-xs text-black mont-font text-white uppercase bg-[#0b2545]">
                                    <tr className='border border-gray-300'>
                                        <th className="px-6 py-3 border border-gray-300">NAME</th>
                                        <th className="px-6 py-3 border border-gray-300">EMAIL</th>
                                        <th className="px-6 py-3 border border-gray-300">PHONE</th>
                                        <th className="px-6 py-3 border border-gray-300">ROLE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="bg-white border border-gray-300 transition duration-300 ease-in-out hover:bg-gray-200 sen-font">
                                        <td className="px-6 py-4 border border-gray-300">{user && user.name}</td>
                                        <td className="px-6 py-4 border border-gray-300">{user && user.email}</td>
                                        <td className="px-6 py-4 border border-gray-300">{user && user.phone}</td>
                                        <td className="px-6 py-4 border border-gray-300 uppercase">{user && user.role}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                ) }
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    authDetails: state.authDetails,
    authUpdate: state.authUpdate
})

export default connect(mapStateToProps, { getSingleUserDetails, putSingleUserUpdate } )(ProfileUpdateScreen);